import Heading from '../../sharedComponents/Heading/Heading';
import './Demo.scss';
import { ReactComponent as ArrowForward } from '../../../assets/icons/arrow_forward.svg';
import Button from '../../sharedComponents/Button/Button';
import { useNavigate } from 'react-router-dom';
function Demo() {
    const navigate = useNavigate();

    const goToContactUs = () => {
        window.scrollTo(0, 0);
        navigate("/contact");
    }
    return (
        <div id='alpha-perceptron-demo' className='alpha-perceptron-demo'>
            <div className='alpha-perceptron-demo__container'>
                <div className='alpha-perceptron-demo__container__texts'>
                    <Heading size='h2' type='tertiary'>Ready to take your business to new heights?</Heading>
                    <Heading size='h6' type='tertiary'>
                        Ready to unlock the full potential of your business with cutting-edge AI technology? Start your journey
                        towards streamlined operations, enhanced decision-making, and unparalleled growth today.
                    </Heading>
                    <Button onClick={goToContactUs} type='secondary' size='medium' icon={<ArrowForward />}>
                        Request a Demo
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default Demo;

